/* eslint-disable @next/next/no-img-element */
import React, { useContext, useEffect, useRef, useState } from "react";

import classNames from "classnames";
import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";

const StyledContainer = styled.div`
  margin: 150px auto 183px;
  position: relative;
  opacity: ${({ shown }) => (shown ? "1" : "0")};
  transform: ${({ shown }) => (shown ? "translateY(0)" : "translateY(20px)")};
  transition: opacity 0.5s ease, transform 0.5s ease;
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10rem;
    margin: 120px auto 120px;
  }

  .images {
    position: relative;
  }

  .link-container {
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 25px;
    padding-right: 1rem;

    @media (min-width: 768px) {
      padding-right: 2rem;
    }

    @media (min-width: 900px) {
      padding-right: 5rem;
    }

    @media (min-width: 1200px) {
      padding-right: 20rem;
    }

    .header h2 {
      font-size: 60px;
      line-height: 50px;
      padding: 3px 5px;
      background: #24272b;
      transform: scaleY(1.2);
      text-transform: uppercase;
      color: #fff;
      display: inline-block;
      width: auto;
    }

    .link a {
      display: block;
      margin-top: 10px;
      width: 60px;
      height: 60px;
      background: #24272b
        url(//jobs.drmartens.com/wp-content/themes/drmartens/dist/styles/../images/arrow-right-white.svg)
        no-repeat 50% / auto 22px;
      cursor: pointer;
      transition: all 0.2s ease-in-out;

      @media (min-width: 768px) {
        width: 43px;
        height: 43px;
      }
    }

    .story-link {
      padding: 0;
      margin-top: 60px;

      a {
        font-size: 20px;
        line-height: 40px;
        color: #266fb9;
        text-transform: uppercase;
        text-decoration: none;
      }
    }

    @media (min-width: 544px) {
      .header h2 {
        font-size: 120px;
        line-height: 100px;
      }
    }
    @media (min-width: 768px) {
      .header h2 {
        font-size: 83px;
        line-height: 71px;
      }

      .story-link {
        padding: 0 0 0 50px;
        margin-top: 20px;

        a {
          font-size: 15px;
          line-height: 24px;
        }
      }
    }
  }

  .rotated-text {
    font-size: 17px;
    line-height: 27px;
    bottom: 430px;
    left: 25px;
    transform: rotate(-90deg);
    text-transform: uppercase;
    font-weight: 600;
    z-index: 1;
    position: absolute;

    @media (min-width: 768px) {
      font-size: 15px;
      line-height: 24px;
      bottom: 340px;
    }

    span {
      position: absolute;
      top: 0;
      left: 0;
      width: 300px;
    }
  }

  .main-image {
    width: calc(100% - 60px);
    height: 768px;
    left: 60px;
    position: relative;
    background: transparent no-repeat 50% / cover;
    object-fit: cover;

    @media (min-width: 768px) {
      width: 100%;
      height: 665px;
      right: -50px;
    }
  }

  .overlay-image {
    position: absolute;
    width: 400px;
    height: 420px;
    left: 15px;
    bottom: -30px;
    transition: transform 0.2s ease;
    background: transparent no-repeat 50% / cover;
    object-fit: cover;

    @media (min-width: 768px) {
      width: 340px;
      height: 360px;
      left: -25px;
      bottom: -40px;
    }
  }
`;

function AnimatedScrollImage() {
  const {
    image = [],
    rotatedText,
    CSS,
    linkUrl,
    linkText,
    headerText,
    uniqueId,
    wrapperClassName,
  } = useContext(ComponentContext);

  const [isVisible, setIsVisible] = useState(false);
  const [isAlreadyVisible, setIsAlreadyVisible] = useState(false);
  const [offsetY, setOffsetY] = useState(0);
  const imageRef = useRef(null);

  const handleScroll = () => {
    if (isAlreadyVisible) return;

    const rect = imageRef.current.getBoundingClientRect();
    if (rect.top <= window.innerHeight && rect.bottom >= 0) {
      setIsVisible(true);
      setIsAlreadyVisible(true);
    } else {
      setIsVisible(false);
    }

    const newOffsetY = window.scrollY - rect.height;
    setOffsetY(newOffsetY);
  };

  const checkInitialVisibility = () => {
    const rect = imageRef.current.getBoundingClientRect();
    if (rect.top <= window.innerHeight && rect.bottom >= 0) {
      setIsVisible(true);
      setIsAlreadyVisible(true);
    }
  };

  useEffect(() => {
    checkInitialVisibility();
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <StyledContainer
      ref={imageRef}
      className={classNames(wrapperClassName, "animated-scroll-image")}
      dynamicStyles={CSS}
      id={uniqueId}
      shown={isVisible}
    >
      <div className="images">
        <img
          alt={image.data[0]?.alternativeText}
          className="main-image"
          src={image.data[0]?.url}
        />
        <div className="rotated-text">
          <span>{rotatedText}</span>
        </div>
        <img
          alt={image.data[1]?.alternativeText}
          className="overlay-image"
          src={image.data[1]?.url}
          style={{ transform: `translateY(${offsetY * 0.02}px)` }}
        />
      </div>
      <div className="link-container">
        <div className="text-wrapper">
          <div className="header">
            <h2>{headerText}</h2>
          </div>
          <div className="link">
            <a href={linkUrl}> </a>
          </div>
          <div className="story-link">
            <a href={linkUrl}>{linkText}</a>
          </div>
        </div>
      </div>
    </StyledContainer>
  );
}

export default AnimatedScrollImage;
